import { NgModule } from '@angular/core';
import { AreaImageComponent } from './areaImage.component';

@NgModule({
  declarations: [
    AreaImageComponent,
  ],
  exports: [
    AreaImageComponent,
  ],
})
export class AreaImageModule {}



// WEBPACK FOOTER //
// ./src/app/common/components/AreaImageComponent/areaImage.module.ts